import { render, staticRenderFns } from "./newVideoForm.vue?vue&type=template&id=3778714d"
import script from "./newVideoForm.vue?vue&type=script&lang=js"
export * from "./newVideoForm.vue?vue&type=script&lang=js"
import style0 from "./newVideoForm.vue?vue&type=style&index=0&id=3778714d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports